import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { useCopy } from '@libs/hooks';
import { CopiedIcon, CopyIcon } from '../assets';
import { CopyButton, CustomTypography, ImgContainer } from './styles';
const Copy = ({ text, buttonTextBeforeCopying, buttonTextAfterCopying, className, backgroundColor, shouldDisplayText = true, color, activeIconColor, }) => {
    const { colors } = useTheme();
    const { isCounterRunning, handleCopy } = useCopy(text);
    const textColor = isCounterRunning
        ? colors.text.interactive
        : colors.text.default;
    const textColorSecondary = color ? color : textColor;
    const copyText = isCounterRunning
        ? buttonTextAfterCopying
        : buttonTextBeforeCopying;
    return (_jsxs(CopyButton, { className: className, status: isCounterRunning, onClick: handleCopy, backgroundColor: backgroundColor, children: [shouldDisplayText && (_jsx(CustomTypography, { type: 'caption', fontFamily: 'primaryMedium', color: textColorSecondary, children: copyText })), _jsx(ImgContainer, { children: isCounterRunning ? (_jsx(CopiedIcon, { color: activeIconColor || colors.text.interactive, testId: "copyIcon" })) : (_jsx(CopyIcon, { testId: "copyIcon" })) })] }));
};
export default Copy;
//# sourceMappingURL=Copy.js.map